import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMDXComponents as _provideComponents } from "next-mdx-import-source-file";
function _createMdxContent(props) {
    const _components = Object.assign({
        p: "p",
        h2: "h2"
    }, _provideComponents(), props.components);
    return _jsxs(_Fragment, {
        children: [
            _jsx(_components.p, {
                children: 'asadatik.dev may contain links to external websites or resources that are not owned or operated by Asaduzzaman Atik ("I," "me," "my," or "mine"). These external links are provided for your convenience and informational purposes only. By clicking on these links, you acknowledge that you are leaving asadatik.dev and accessing third-party websites at your own risk. 👍'
            }),
            "\n",
            _jsx(_components.h2, {
                children: "1. Third-Party Websites 🔗"
            }),
            "\n",
            _jsx(_components.p, {
                children: "I have no control over the content, policies, or practices of these external websites. I do not endorse or make any representations about these websites' accuracy, safety, or appropriateness for any purpose. The inclusion of any external link on asadatik.dev does not imply my endorsement or approval of the linked site."
            }),
            "\n",
            _jsx(_components.h2, {
                children: "2. Privacy and Security 🔐"
            }),
            "\n",
            _jsx(_components.p, {
                children: "Please be aware that when you click on an external link, you will be subject to that site's privacy policy and terms of service, which may differ from those of asadatik.dev. I encourage you to review the privacy policies and terms of use of any third-party site you visit to understand how your data will be collected, used, and protected."
            }),
            "\n",
            _jsx(_components.h2, {
                children: "3. Exercise Caution 🚫"
            }),
            "\n",
            _jsx(_components.p, {
                children: "When visiting external websites, exercise caution and be aware of potential risks. I cannot be held responsible for any loss, damage, or harm resulting from your use of external websites."
            }),
            "\n",
            _jsx(_components.h2, {
                children: "4. Contact 📞"
            }),
            "\n",
            _jsx(_components.p, {
                children: "If you have any questions or concerns regarding the external links on asadatik.dev or any issues related to these linked sites, please contact me at asadatik.me@gmail.com."
            })
        ]
    });
}
function MDXContent(props = {}) {
    const { wrapper: MDXLayout } = Object.assign({}, _provideComponents(), props.components);
    return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
        children: _jsx(_createMdxContent, props)
    })) : _createMdxContent(props);
}
export default MDXContent;
